import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=4a3e1367&"
import script from "./privacy.vue?vue&type=script&lang=ts&"
export * from "./privacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports